import {
  Ripple,
  initTE,
  Carousel,
  Modal,
  Stepper,
  Tooltip,
  Input,
} from "tw-elements";

initTE({ Ripple, Modal, Carousel, Stepper, Tooltip, Input });
